module.exports = __webpack_public_path__ + "img/portfolio_4.5cb03457.png";